<div class="unsupported-container">
  <div class="img-container">
    <img src="../../assets/images/unsupported-browser.svg" />
  </div>
  <div class="msg-container">
    <p class="title">{{ 'message.unsupportedbrowser-title' | translate }}</p>
    <p class="msg">{{ 'message.unsupportedbrowser-message' | translate }}</p>
  </div>
</div>
